<template>
  <div class="contract-details-display">
    <div class="row">
      <div class="col-sm-6">
        <vue-form :options="{
          permalink: 'generateRebatePromoReport',
          params: {
            TrailingRebatePromoUuid: this.$route.params.promo
          }
        }">
        </vue-form>
        <div class="card card-primary mt-2">
           <div class="card-header">
            Company Details
          </div>
          <div class="card-body">
            <router-link class="btn-xs btn btn-warning mb-2" :to="'/membership/trailing-rebate-promotions/edit/' + trailingRebatePromo.uuid">
              <span class="fa fa-edit fa-fw"></span> Edit
            </router-link>
            <accordian-display :icon="'fa-file-alt'" title="Trailing Rebate Promo Particulars" :default-open="true">
              <tr>
                <td class="font-weight-bold">Company</td>
                <td>
                  {{ trailingRebatePromo.companyName }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Company Address</td>
                <td>
                  {{ trailingRebatePromo.companyAddress }}<br/>
                  {{ trailingRebatePromo.companySuburb }} {{ trailingRebatePromo.companyPostcode }}<br/>
                  {{ trailingRebatePromo.companyState }} {{ trailingRebatePromo.companyCountry }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Phone</td>
                <td>
                  {{ trailingRebatePromo.companyPhone }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Email</td>
                <td>
                  {{ trailingRebatePromo.companyEmail }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">ABN</td>
                <td>
                  {{ trailingRebatePromo.companyAbn }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">ACN</td>
                <td>
                  {{ trailingRebatePromo.companyAcn }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Rebate to Client</td>
                <td>
                  {{ trailingRebatePromo.percentRebate }}%
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Organization</td>
                <td>
                  {{ trailingRebatePromo.Organization.companyName }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Account Promo Code</td>
                <td>
                  {{ trailingRebatePromo.PromoCode.code }}
                </td>
              </tr>
            </accordian-display>
            <accordian-display :icon="'fa-user'" title="Bank Account Details">
              <tr>
                <td class="font-weight-bold">Beneficiary Name</td>
                <td>
                  {{ trailingRebatePromo.billingName }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">BSB</td>
                <td>
                  {{ trailingRebatePromo.billingBsb }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Account Number</td>
                <td>
                  {{ trailingRebatePromo.billingAccountNumber }}
                </td>
              </tr>
            </accordian-display>
            <accordian-display :icon="'fa-user'" title="Point of Contact">
              <tr>
                <td class="font-weight-bold">Contact Person</td>
                <td>
                  {{ trailingRebatePromo.contactPerson }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Phone</td>
                <td>
                  {{ trailingRebatePromo.contactPhone }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Email</td>
                <td>
                  <a :href="`mailto:${trailingRebatePromo.contactEmail}`">{{ trailingRebatePromo.contactEmail }}</a>
                </td>
              </tr>
            </accordian-display>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card card-primary">
          <div class="card-header">
            Accounts Used this Promo
          </div>
          <div class="card-body">
            <template v-for="account in trailingRebatePromo.PromoCode.Accounts">
              <accordian-display :icon="'fa-car'" :title="account.dropdownLabel" :key="account.uuid">
                <tr>
                  <td class="font-weight-bold">Account Type</td>
                  <td>
                    {{ account.AccountType.name }}
                  </td>
                </tr>
              </accordian-display>
            </template>
            <span v-if='!usedYet'>None of the accounts has used this Promo Code yet. </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordianDisplay from '@/components/displays/AccordianDisplay'
import VueForm from '@/components/Form'
import { LOAD_TRAILING_REBATE_PROMO_DETAILS } from '@/vuex/types'
import { mapGetters } from 'vuex'

export default {
  name: 'RebatePromoDetailsDisplay',
  components: {
    AccordianDisplay,
    VueForm
  },
  computed: {
    ...mapGetters([
      'trailingRebatePromo'
    ]),
    usedYet () {
    // Has any member used this promo code?
      return this.trailingRebatePromo.PromoCode.Accounts.length > 0
    }
  },
  mounted () {
    this.$store.dispatch(LOAD_TRAILING_REBATE_PROMO_DETAILS, this.$route.params.promo)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/RebatePromoDetailsDisplay.vue